export default __webpack_public_path__ + "static/media/favourite-fill-icon.666e1336.svg";